module.exports = __webpack_public_path__ + "static/media/4415.ae4aa70f.jpg";